import {assert} from 'Asserts';
import {
  FlowchartStaticEdgeData,
  ProcessFlowchartEdgeType,
  TaskSchemaNodeSectionType,
  TransitionSource,
} from 'processes/modals/field-mapping/transition-modal-with-flowchart-editor/transitionModalWithFlowchartEditorConstants';

import {doesDataFlowEdgeHandleReferenceRow} from './flowchartIdentifierUtils';
import {TaskSchemaNodeSectionData} from './processFlowchartConfigEditorNodeTypes';

export function getNodeSectionTypeFromDataFlowEdge(
  edge: FlowchartStaticEdgeData,
  nodes: Array<{id: string; sections: Array<TaskSchemaNodeSectionData>}>
): TaskSchemaNodeSectionType {
  assert(edge.type === ProcessFlowchartEdgeType.DATA_FLOW, 'Expected data flow edge');
  const sourceNode = nodes.find((node) => node.id === edge.source)!;
  assert(sourceNode != null, 'Expected source node to be found');

  for (const section of sourceNode.sections) {
    for (const row of section.sectionRows) {
      if (doesDataFlowEdgeHandleReferenceRow(edge.sourceHandle, row.id)) {
        return section.sectionType;
      }
    }
  }
  assert(false, 'Expected data flow edge to reference a row');
}

export function getDefaultTransitionSource(
  sourceNodeId: string,
  nodes: Array<{id: string; sections: Array<TaskSchemaNodeSectionData>}>
): TransitionSource {
  const sourceNode = nodes.find((node) => node.id === sourceNodeId);
  assert(sourceNode != null, 'Expected source node to be found');
  const hasOutputSection = sourceNode.sections.some(
    (section) => section.sectionType === TaskSchemaNodeSectionType.OUTPUTS
  );
  return hasOutputSection ? TransitionSource.OUTPUTS : TransitionSource.INPUTS;
}

export function getTransitionSourceByNodeIdPairKey(sourceNodeId: string, targetNodeId: string): string {
  return `${sourceNodeId}:${targetNodeId}`;
}
